import { Col, Progress, Spin } from "antd";
import ContainerLayout from "../../common/containerLayout";
import GroupTripsMap from "../groupTripsMap/groupTripsMap";
import FormAddGroupTrip from "./formAddGroupTrip";
import { validateDTO } from "../../../shared/dtos/PassengerGroupDTO";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import { useEffect } from "react";
import { setDirectionResponse } from "../../../features/groupTrip/groupTripsMap/groupTripsMapSlide";

const DispatcherGroupTrip = (): JSX.Element => {
  const validate: validateDTO = useAppSelector(
    (state) => state.passeger.validating,
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    return () => {
      dispatch(setDirectionResponse(null));
    };
  }, [dispatch]);

  return (
    <ContainerLayout title="Crear viaje en grupo" gutter={32}>
      {validate.active && (
        <Spin
          tip={`${validate.completed}/${validate.total}`}
          spinning={validate.active}
        >
          <Progress percent={(validate.completed * 100) / validate.total} />
        </Spin>
      )}
      <Col span={8}>
        <FormAddGroupTrip />
      </Col>
      <Col span={16}>
        <GroupTripsMap height="90vh" />
      </Col>
    </ContainerLayout>
  );
};

export default DispatcherGroupTrip;
